import { PropsWithChildren, useEffect, useRef } from 'react';

interface IProps {
  className?: string;
  onClickAway?: () => void;
}

export const ClickAwayListener = ({
  className,
  onClickAway,
  children,
}: PropsWithChildren<IProps>) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClickAway?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [onClickAway]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};
